import { Fonts, GlobalStyle, RootThemeProvider } from '@oriola-corporation/ui-components';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

const root = createRoot(document.getElementById('root') as Element);
root.render(
  <RootThemeProvider>
    <App />
    <GlobalStyle />
    <Fonts />
  </RootThemeProvider>
);
